export default __webpack_public_path__ + "static/media/tiktok.f0a7b2d3.png";